export const changeAvailabilityRequestOptions = [
  'Available',
  'Unavailable',
] as const;
export type ChangeAvailabilityRequestOption =
  (typeof changeAvailabilityRequestOptions)[number];
